export default `import java.util.HashMap;

import io.jsonwebtoken.Jwts;
import io.jsonwebtoken.SignatureAlgorithm;

public class CannyTokenCreator {
  private static final String PrivateKey = "YOUR_PRIVATE_SSO_KEY";

  public static String createToken(User user) throws Exception {
    HashMap<String, Object> userData = new HashMap<String, Object>();
    userData.put("avatarURL", user.avatarURL); // optional, but preferred
    userData.put("email", user.email);
    userData.put("id", user.id);
    userData.put("name", user.name);

    return Jwts.builder()
               .setClaims(userData)
               .signWith(SignatureAlgorithm.HS256, PrivateKey.getBytes("UTF-8"))
               .compact();
  }
}`;
